<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:45px;">About the Author</h1>
<p>Ryan M Love was born in Kent. Following an education in horticulture, he worked principally as a gardener until a keen interest in modern military history inspired him to begin writing fiction. Having a passion for the outdoor life, he is an avid mountain biker, snowboarder and trail runner. He currently lives in Wales, just outside the Brecon Beacons National Park.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?53a9a3bc